import MojitoCore from 'mojito/core';
import CmsSportCouponView from './view/index.js';
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class CmsSportCoupon extends UIViewImplementation {
    constructor(props) {
        super(props);
        this.onChildLoaded = this.onChildLoaded.bind(this);
    }
    onChildLoaded() {
        this.props.onDataLoad();
    }
    render() {
        return (
            <div className="CmsSportCoupon ta-CmsSportCoupon">
                <CmsSportCouponView
                    config={this.config.view}
                    sportId={this.props.sportId}
                    couponId={this.props.couponId}
                    couponName={this.props.couponName}
                    onDataLoad={this.onChildLoaded}
                />
            </div>
        );
    }
}

CmsSportCoupon.getStyle = function () {
    return {};
};
